import React, { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import yup from '../../../libs/yup/yup';
import Swal from 'sweetalert2';
import { Controller, useForm } from 'react-hook-form';
import { withdrawBalance } from '../../../api/sportaloka-client';
import TextInput from '../../../components/form/TextInput';

const defaultValues = {
  bank_account_id: '',
  amount: 0
};

const schema = yup.object().shape({
  bank_account_id: yup.string().label('Rekening Bank').required('${label} wajib diisi'),
  amount: yup.number().label('Jumlah Penarikan').required('${label} wajib diisi').min(1)
});

function WithdrawBalanceModal({ onSubmitted, bankAccounts }) {
  const [loading, setLoading] = useState(false);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema)
  });

  const onSubmit = async (val) => {
    try {
      setLoading(true);
      await withdrawBalance(val);
      Swal.fire({
        title: 'Berhasil!',
        text: 'berhasil mengajukan penarikan saldo',
        icon: 'success',
        confirmButtonText: 'Tutup'
      });
      reset();
      document.getElementById('closeModal').click();
      onSubmitted();
      setLoading(false);
    } catch (error) {
      if (error.response.status === 409) {
        Swal.fire({
          title: 'Gagal!',
          text: `Saldo tidak cukup`,
          icon: 'error',
          confirmButtonText: 'Tutup'
        });
      } else {
        Swal.fire({
          title: 'Gagal!',
          text: 'Periksa koneksi anda dan coba kembali.',
          icon: 'error',
          confirmButtonText: 'Tutup'
        });
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleModalHidden = () => {
      reset();
    };

    const modalElement = document.getElementById('withdrawBalanceModal');
    modalElement.addEventListener('hidden.bs.modal', handleModalHidden);

    return () => {
      modalElement.removeEventListener('hidden.bs.modal', handleModalHidden);
    };
  }, [reset]);

  return (
    <div className="modal" tabIndex="-1" id="withdrawBalanceModal">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Tarik Saldo</h5>
            <button
              id="closeModal"
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-12">
                  <Controller
                    control={control}
                    name="bank_account_id"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <div className="form-group">
                        <label>
                          Pilih Rekening <span className="text-danger">*</span>
                        </label>
                        <select
                          className={`form-control ${Boolean(errors.bank_account_id) && 'form-error'}`}
                          onChange={onChange}
                          onBlur={onBlur}
                          value={value}>
                          <option value="">Pilih Rekening</option>
                          {bankAccounts.map((bank) => (
                            <option className="fw-600" value={bank.id} key={bank.id}>
                              {`${bank.bank_name} - ${bank.account_number} a/n ${bank.account_name}`}
                            </option>
                          ))}
                        </select>
                        <span className="text-14 text-error text-danger">
                          {Boolean(errors.bank_account_id) && errors.bank_account_id.message}
                        </span>
                      </div>
                    )}
                  />
                </div>
                <div className="col-12">
                  <Controller
                    control={control}
                    name="amount"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <TextInput
                        disabled={loading}
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value}
                        type="number"
                        isRequired={true}
                        label="Jumlah penarikan"
                        isError={Boolean(errors.amount)}
                        errorMessage={Boolean(errors.amount) && errors.amount.message}
                      />
                    )}
                  />
                </div>
                <div className="col-12 text-center">
                  <button
                    disabled={loading}
                    type="submit"
                    className="btn btn-primary bg-blue-1 rounded-1">
                    <span className="fw-500">{loading ? 'Mohon tunggu...' : 'Submit'}</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WithdrawBalanceModal;
